import { useCallback, useSyncExternalStore } from "react";

/**
 * Hook to check if a media query matches
 * @param query - CSS media query string (e.g., "(min-width: 640px)")
 * @returns boolean indicating if the query matches
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === "undefined") return () => {};
      const mediaQuery = window.matchMedia(query);
      mediaQuery.addEventListener("change", onChange);
      return () => mediaQuery.removeEventListener("change", onChange);
    },
    [query],
  );

  return useSyncExternalStore(
    subscribe,
    () =>
      typeof window !== "undefined" ? window.matchMedia(query).matches : false,
    () => false,
  );
}

/**
 * Convenience hook for checking if screen is mobile (< 640px)
 */
export function useIsMobile(): boolean {
  return !useMediaQuery("(min-width: 640px)");
}

/**
 * Convenience hook for checking if screen is desktop (>= 640px)
 */
export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 640px)");
}
